import React from 'react';
import { connect } from 'react-redux';
import Login from './login';
import './style.scss';

function LoginPage({ isMobile }) {
    return (
        <div className="login-page">
            <Login />
            {!isMobile && (
                <div className="login-page__main-header">
                    <h1>
                        Автоматизированная система мониторинга<br />
                        проектов нормативных правовых актов
                    </h1>
                </div>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
});

export default connect(mapStateToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/routes/login-page/index.js